import { queryOptions } from "./v4QueryOptions/queryOptions"
import ShivversService from "../api/ShivversService";
export const getDealerIdOptions = () => {
    return queryOptions({
        queryKey: ["dealerIds"],
        queryFn: async (q) => {
            return await ShivversService.getDealers(q.signal);
        }
    })
}